import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Student } from '../../shared-components/student/student.model';
import { StudentService } from '../../shared-components/student/student.service';

@Component({
    selector: 'app-portal-access-denied',
    templateUrl: './portal-access-denied.component.html'
})
export class PortalAccessDeniedComponent {

    portalName: string;
    student: Student;

    @Output() revertToStudentSummary = new EventEmitter();

    constructor(
        private studentService: StudentService,
        private dialog: MatDialogRef<PortalAccessDeniedComponent>
    ) {
        this.student = this.studentService.selectedStudent;
    }

    closeClick() {
        this.revertToStudentSummary.emit();
        this.dialog.close();
    }
}
